import { render, staticRenderFns } from "./SectionsGestionCabinet.vue?vue&type=template&id=cd766332&"
import script from "./SectionsGestionCabinet.vue?vue&type=script&lang=js&"
export * from "./SectionsGestionCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports